export default __webpack_public_path__ + "static/ms-jack-sparrow-84cde35e14dc8fb130e34d193948e633.jpg";